import React from 'react';
import { Input, Icon, AutoComplete } from 'antd';

const isNumber = (value) => {
    const reg = /^([0-9]*)$/;
    let res = !isNaN(value) && reg.test(value);
    return res;
}

export default class PhoneNumberInput extends React.Component {

    onChange = (e) => {
        const { value } = e.target;
        if (isNumber(value) || value === '') {
            this.props.onChange(value);
        }
    }

    handleClearClick = () => {
        this.props.onChange('');
    }

    render() {
        let rp = { ...this.props };
        delete rp.allowClear;

        return (
            <Input {...rp}
                onChange={this.onChange}
                placeholder={rp.placeholder || 'телефон'}
                maxLength={10}
                suffix={(this.props.allowClear && this.props.value && this.props.value !== '') &&
                    <span
                        onClick={this.handleClearClick}
                        className="dspx-input-value__clear" unselectable="on" style={{ userSelect: "none" }} >
                        <Icon type="close-circle" theme="filled" />
                    </span> || <span/>
                } 
            />
        )
    }
}

const PhoneNumberAutoComplete = React.forwardRef(({inputProps, ...props}, ref) => {
    const handleChange = (value) => {
        if (isNumber(value) || value === '') {
            props.onChange(value);
        }
    }

    return <AutoComplete
        ref={ref}
        {...props}
        onChange={handleChange}
        getPopupContainer={trigger => trigger.parentElement}
        dataSource={
            props.applicants.map(applicant => ({value: applicant.phone, text: applicant.phone}))
        }
    >
        <Input maxLength={10} {...inputProps} placeholder="телефон"  />
    </AutoComplete>
})

export {PhoneNumberAutoComplete}
